<template>

  <transition name="fade">
    <router-view></router-view>
  </transition>

</template>

<script>
import { AmplifyEventBus } from 'aws-amplify-vue'
import Authentication from "@/services/authentication";

export default {
  name: 'app',
  data() {
    return {
      signedIn: false,
      isLoaded: false
    }
  },
  beforeCreate() {
    AmplifyEventBus.$on('authState', info => {
      if (info === 'signedIn') {
        this.signedIn = true
        this.$router.push('/profile')
      }
      if (info === 'signedOut') {
        this.$router.push('/auth')
        this.signedIn = false
      }
    });

    Authentication.getCurrentUser()
      // eslint-disable-next-line
      .then(user => {
        this.signedIn = true
      })
      .catch(() => this.signedIn = false);
  },
  created: function() {
    document.getElementById("loader").classList.add("loaded");
    const iOS =
      !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    if (iOS === true) {
      document.getElementById("body").classList.add("ios");
    }
  }
}
</script>

<style lang="scss">
  .nav {
    display: flex;
  }
  .nav p {
    padding: 0px 30px 0px 0px;
    font-size: 18px;
    color: #000;
  }
  .nav p:hover {
    opacity: .7;
  }
  .nav p a {
    text-decoration: none;
  }
  .sign-out {
    width: 160px;
    margin: 0 auto;
  }

  .fade-enter-active {
    transition: opacity 1s;
  }

  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  @import "~bootstrap/scss/bootstrap-reboot.scss";
  @import "~bootstrap/scss/bootstrap-grid.scss";
  @import "~bootstrap/scss/modal.scss";
  @import "bootstrap-vue/dist/bootstrap-vue.css";
  @import "assets/css/style.scss";
</style>
